<template>
  <div>
    <base-crud crudName="Temas" newText="Novo Tema" :table="themeTable" :columns="columns" :options="options"
      :endPoint='endPoint' :enableAdd="true" :enableEdit="true" :enableDelete="true" :enableView="false" :enablePdf="true">
    </base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      themeTable: "themeTable",
      teams: [],
      pages: [],
      url: "",
      columns: ["id", "title", "photo", "theme_category_id", "document", 'question', 'active_status', "actions"],
      tableData: ["id", "title", "photo", "theme_category_id", "document", 'question', 'active_status'],
      options: {
        filterable: ["id", "title", "document", "question", "theme_category_id", "active_status"],
        filterByColumn: true,
        sortable: ["id", "title"],
        templates: {
          theme_category_id: function (h, row, index) {
            return row.theme_category ? row.theme_category.description : '';
          },
          active_status: function (h, row, index) {
            return row.active_status == 1 ? "Ativo" : "Inativo";
          },
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Título",
          photo: "Foto",
          document: "Documento",
          question: "Perguntas",
          theme_category_id: "Temas",
          active_status: "Ativo/Inativo",
          actions: "Ações"
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ['theme_category'];

          console.log(query);

          return this.$http
            .get(this.url + '?' + query, requestData)
            .then((response) => {

              return response;
            })
            .catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        }
      },
      endPoint: "themes/"
    };
  },
  methods: {
    condition(){
      
    },
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        document: "document",
        question: "question",
        theme_category_id: "theme_category[description]",
        active_status: "active_status"
      };
      let filters = "";
      $.each(query, function (index, value) {
        if (index == "active_status" ) {
          
          value = value.toLowerCase() == "ativo" ? 1 : 0;
        }
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    }
  },
  components: {
    BaseCrud
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Theme/Crud.vue